import { render, staticRenderFns } from "./PageBreak.vue?vue&type=template&id=636cf448&scoped=true&"
import script from "./PageBreak.vue?vue&type=script&lang=js&"
export * from "./PageBreak.vue?vue&type=script&lang=js&"
import style0 from "./PageBreak.vue?vue&type=style&index=0&id=636cf448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "636cf448",
  null
  
)

export default component.exports